export const POLYGON_CHAIN_ID = 137;
